import { documentationLinks } from './documentation';
export function getAPIDomain() {
    const domain = process.env.API_DOMAIN; //This only is defined when running with webpack serve
    if (domain)
        return domain;
    //@ts-ignore
    return window.PORTAL_URL || '';
}
export function getAPI() {
    const domain = getAPIDomain();
    return `${domain}/api`;
}
export function getJobsDomain() {
    const domain = typeof process !== 'undefined' ? process.env.JOBS_DOMAIN : undefined;
    if (domain)
        return domain;
    //@ts-ignore
    return window.JOBS_URL || '';
}
export function getStyleDomain() {
    return process.env.STYLE_DOMAIN || 'https://localhost:3011';
}
// export function getMSALConfiguration(): AUTH_CONFIG {
//   return {
//     clientId: process.env.AUTH_CLIENTID || 'please configure AUTH_CLIENT in environment',
//     authority: `https://login.microsoftonline.com/${process.env.AUTH_TENANTID}`,
//     tenantId: process.env.AUTH_TENANTID || 'please configure AUTH_TENANTID in environment',
//     scopes: [process.env.AUTH_SCOPE || 'please configure AUTH_SCOPE in environment'],
//     redirectUri: process.env.AUTH_REDIRECT || 'please configure AUTH_REDIRECT in environment',
//     audience: process.env.AUTH_AUDIENCE || 'please configure AUTH_AUDIENCE in environment',
//   }
// }
let msalConfig = {
    clientId: '',
    tenantId: '',
    scopes: [''],
    redirectUri: '',
};
let authorizationConfig = {
    apiscope: '',
};
// export function updateConfig(config: any) {
//   msalConfig = config.authentication
//   authorizationConfig = config.authorization
//   mapboxApiKey = config.mapbox?.apiKey
//   maintenanceConfig = config.maintenance
//   environment = config.environment
// }
//2025-05-01 Garth needed the above to change to this.
export function updateConfig(config) {
    var _a, _b;
    documentation = documentationLinks((_a = config.documentation) === null || _a === void 0 ? void 0 : _a.origin);
    msalConfig = config.authentication;
    msalConfig.redirectUri = window.location.origin;
    authorizationConfig = config.authorization;
    mapboxApiKey = (_b = config.mapbox) === null || _b === void 0 ? void 0 : _b.apiKey;
    maintenanceConfig = config.maintenance;
    environment = config.environment;
}
let documentation = documentationLinks();
export function getDocumentationLinks() {
    return documentation;
}
export function getMSALConfiguration() {
    return msalConfig;
}
export function getAuthorizationConfig() {
    return authorizationConfig;
}
// export function getAuthorizationConfiguration(): any {
//   return {
//     api_scope: process.env.API_SCOPE || 'please configure API_SCOPE in environment',
//     powerbi_scope: process.env.POWERBI_SCOPE || 'please configure POWERBI_SCOPE in environment',
//   }
// }
// export function getMapboxApiKey(): string {
//   return process.env.MAPBOX_APIKEY || ''
// }
let mapboxApiKey = '';
export function getMapboxApiKey() {
    return mapboxApiKey;
}
// mapbox config
export const mapViewBounds = [151.16421979021112, -23.936097502120106, 151.561501328845, -23.747372156540326];
let maintenanceConfig = 'False';
export function getMaintenance() {
    return maintenanceConfig;
}
let environment = 'production';
export function getEnvironment() {
    return environment;
}
